'use client';

import classNames from 'classnames';
import { LandingSetupAndCost } from '@sapientpro/sapientpro-data-models/types/components/landing-page';
import styles from './PriceList.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Card from './Card';

const getArrayMiddleIndex = (arr: unknown[]) => (arr.length - 1) / 2;

const PriceList = ({
  data,
}: {
  data: LandingSetupAndCost;
}) => (
  <section className={classNames(styles.priceList, 'container')}>
    <h2 className={classNames(styles.priceList__title, 'header2')}>
      <AnimatedTitle title={data.title} />
    </h2>
    <div className={styles.priceList__content}>
      {data.cards.map((card, index, arr) => (
        <div
          key={card.id}
          className={classNames(styles.priceList__card, { [styles.priceList__card_primary]: getArrayMiddleIndex(arr) === index })}
        >
          <Card
            icon={card.icon}
            title={card.title}
            subtitle={card.subtitle}
            points={[card.point1, card.point2, card.point3].filter((point): point is string => !!point)}
            calendly={card.calendly} // TODO: Add calendly link when API is ready
            buttonText={card.ctaButton}
            isPrimary={getArrayMiddleIndex(arr) === index}
          />
        </div>
      ))}
    </div>
  </section>
);

export default PriceList;
